import Icon from '../components/Icon.vue'

Icon.register({"bars":{"width":448,"height":512,"paths":[{"d":"M16 132H432C440.8 132 448 124.8 448 116V76C448 67.2 440.8 60 432 60H16C7.2 60 0 67.2 0 76V116C0 124.8 7.2 132 16 132zM16 292H432C440.8 292 448 284.8 448 276V236C448 227.2 440.8 220 432 220H16C7.2 220 0 227.2 0 236V276C0 284.8 7.2 292 16 292zM16 452H432C440.8 452 448 444.8 448 436V396C448 387.2 440.8 380 432 380H16C7.2 380 0 387.2 0 396V436C0 444.8 7.2 452 16 452z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bars.js
// module id = inJg
// module chunks = 0